import { PictureAsPdfSharp } from '@mui/icons-material'
import { MenuItem } from '@mui/material'
import { useCreateOrderProposalPdf } from 'modules/orders/hooks'
import { ActionsItemProps } from './actions'

export const ProposalPdf = ({ order, disabled }: ActionsItemProps) => {
  const { mutate, isLoading } = useCreateOrderProposalPdf()

  const handleClick = () => {
    mutate({ proposalId: order.proposalId })
  }

  return (
    <MenuItem disabled={isLoading || disabled} onClick={handleClick}>
      <PictureAsPdfSharp />
      Gerar PDF
    </MenuItem>
  )
}
